export default 'icon--share';